import { render, staticRenderFns } from "./LensEmptyState.vue?vue&type=template&id=521ffefa"
import script from "./LensEmptyState.vue?vue&type=script&lang=js"
export * from "./LensEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports